import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Inspector Name',
    field: 'inspectorName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Inspection Count',
    field: 'eventCount',
    filter: 'numeric',
    searchable: true,
  },
];
